/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.inventario': 'Inventory',
  'sidebar.gestionproducto': 'Product management',
  'gestionproducto.agregarProducto': 'Create product',
  'gestionproducto.editarProducto': 'Edit productt',
  'gestionproducto.medido.dimensiones': 'Cm',
  'gestionproducto.medido.peso': 'Kg',
  'gestionproducto.Abreviatura': 'Short name',
  'gestionproducto.CodigoBarras': 'Barcode',
  'gestionproducto.DescripcionItem': 'Description item',
  'gestionproducto.Modelo': 'Model',
  'gestionproducto.Estado': 'State',
  'gestionproducto.Contenedor': 'Container',
  'gestionproducto.Importado': 'Imported',
  'gestionproducto.Lotes': 'Handles Lots',
  'gestionproducto.Manejapeso': 'Handles weight',
  'gestionproducto.ManejaPeso': 'Handles weight',
  'gestionproducto.Seriado': 'Serial',
  'gestionproducto.Serialconsecutivo': 'Consecutive serial',
  'gestionproducto.DescripcionUnidad': 'Unit description',
  'gestionproducto.FabricanteDescripcion': 'Manufacturer description',
  'gestionproducto.FamiliaDescripcion': 'Family description',
  'gestionproducto.ClasificacionDescripcion': 'Activity description',
  'gestionproducto.Familia': 'Family',
  'gestionproducto.Unidad': 'Unity',
  'gestionproducto.Clasificacion': 'Activity',
  'gestionproducto.ClaseTecnica': 'Technical class',
  'gestionproducto.Referencia': 'Reference',
  'gestionproducto.Marca': 'Brand',
  'gestionproducto.Fabricante': 'Maker',
  'gestionproducto.Ancho': 'Width',
  'gestionproducto.Alto': 'High',
  'gestionproducto.Peso': 'Weight',
  'gestionproducto.Largo': 'Long',
  'gestionproducto.verImagen': 'Images',
  'gestionproducto.RfId': 'RFID',
  'gestionproducto.FIFO': 'FIFO',
  'gestionproducto.FEFO': 'FEFO',
  'gestionproducto.Valor': 'Value',
  'gestionproducto.Valor.Monto': '$',
  'gestionproducto.itemSeleccionado': 'Selected item',
  'gestionproducto.titulo.agregarUnidades': 'Add unit',
  'gestionproducto.titulo.editarUnidades': 'Edit unit',
  'gestionproducto.titulo.datosProducto': 'Product data',
  'gestionproducto.titulo.dimensionesProducto': 'Product dimensions',
  'gestionproducto.titulo.configuracionProducto': 'Product configuration',
  'gestionproducto.titulo.unidadesDeConversion': 'Conversion units',
  'gestionproducto.alerta.seleccionarUnidad': 'Please select a unit to add the conversion units',
  'gestionproducto.alerta.medidasInvalidas': 'The dimensions entered must be greater than 0',
  'gestionproducto.alerta.codigoBarrasInvalido': 'The barcode entered does not correspond to the selected product',
  // componente imagenes
  'gestionproducto.seleccionarItem': 'Selection item',
  'gestionproducto.rotarDerecha': 'Rotate 90°',
  'gestionproducto.rotarIzquierda': 'Rotate -90°',
  'gestionproducto.alerta.limiteImagenes': 'Maximum images exceeded',
  'gestionproducto.alerta.archivoInvalido': 'The type of file entered is invalid',
  'gestionproducto.alerta.eliminarImagen': 'Are you sure you want to delete the image?',
  'gestionproducto.productoSinImagenes': 'No uploaded images',
  'gestionproducto.tamañoImagenes': 'It is recommended to use a square image',
  'gestionproducto.nombreArchivoExcel': 'Products',
  'gestionproducto.FamiliaInactivo':'Family record is inactive, select a new one.',
  'gestionproducto.ClasificacionInactivo':'Classification record is inactive, select a new one.',
  'gestionproducto.ClaseTecnicaInactivo':'Technical class record is inactive, select a new one.',
  'gestionproducto.ReferenciaInactivo':'Reference record is inactive, select a new one.',
  'gestionproducto.MarcaInactivo':'Brand record is inactive, select a new one.',
  'gestionproducto.FabricanteInactivo':'Maker record is inactive, select a new one.',
  'gestionproducto.UnidadInactivo':'Unity record is inactive, select a new one.',
  'gestionproducto.camposSerialManejaPeso':'If the Manage Weight box is checked, you must also select the Serialized or Consecutive Serialized box.',
  'gestionproducto.CodigoEmpresa':'Product code'
};
